import { Outlet } from "react-router";

/**
 * Full-screen layout for public flow pages (/p/:token/*).
 * Bypasses the root layout's container styling — the page handles its own layout.
 * Ported from app/s/[flowId]/layout.tsx.
 */
export default function PublicFlowLayout() {
  return (
    <div className="fixed inset-0 overflow-auto">
      <Outlet />
    </div>
  );
}
